import React from "react";
import { Alert, Box, Button } from "@mui/material";
import { MainPaper } from "./Papers";

interface GeneralAlertProps {
  errorMessage: string;
  action: () => void;
  actionLabel: string;
}

const GeneralAlert: React.FC<GeneralAlertProps> = ({
  errorMessage,
  action,
  actionLabel,
}) => {
  return (
    <MainPaper>
      <Alert severity="error">{errorMessage}</Alert>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Button variant="contained" onClick={action}>
          {actionLabel}
        </Button>
      </Box>
    </MainPaper>
  );
};

export default GeneralAlert;
